module.exports = __webpack_public_path__ + "static/1.einbindung-cc27b1e3669a456b56c356cc9cfd2de2.png";